module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAABF0lEQVQokY3SSy5EURDG8Z8bO0AvoDdg0IKYsATSndaIPZh0rMFjFz0Q74EV6AkSBhbAkMRjamDQkZJz5bq5un2Tyj31/avqnFtjH+0VBWVYxRrmMYVXXOMAhxjk9iJcxxEa/tYd2niUOuXg1Qgw1Ei+eg5naZzaCDBXLfmzADuYKSS3cFkC+uk8V/g7AW+WjMtoFQoE2MSvlw0uK3UNLeE4FdhP4AkWS77pcUxW3CsKbKOLvQowNBGd3yoSMfIOdlPsV3jeA76tAFtp1G6KzYoC9wH3SofnpTtGPMVZydeLDYsCNxUPN0wx7VyAsavxr1/+CYYv/IN8PR+wkHZ3mCIfvvD/7HZeYBbruMATPvGcvjdS/huEL7RiPZCbnB8OAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/mistake.png
// module id = muMi
// module chunks = 1